import React, { useEffect, useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import { useNavigate, useParams } from 'react-router-dom';
import { post, Token, url } from '../../Script/Session';
import { Autocomplete, Box, Button, Card, Chip, FormControl, FormLabel, Input, Link, Table, Textarea, Typography } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';
import debounce from 'lodash/debounce';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';

function ForumViewer() {
    const [wit, setWit] = useState("90.5%");
    const [data, setdata] = useState();
    const { id } = useParams();

    useEffect(() => {
        function fetch() {
            let body = {};
            body.token = Token.get();
            body.action = "getforenthema";
            body.forenid = Number(id);
            let response = post(body, "/forum");
            console.log(response);
            setdata(JSON.parse(response)?.result);
        }
        setTimeout(() => {
            fetch();
        }, 15);

    }, []);
    function update() {
        let body = {};
        body.token = Token.get();
        body.action = "getforenthema";
        body.forenid = Number(id);
        let response = post(body, "/forum");
        setdata(JSON.parse(response)?.result);
    }

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        handler();
        return () => handler.cancel();
    }, [searchTerm]);
    const navigate = useNavigate();
    const [kathdata, setkathdata] = useState();
    const [subs, setsubs] = useState([]);
    useEffect(() => {
        function f() {
            let body = {};
            body.token = Token.get();
            body.action = "get";
            let response = post(body, "/vergleichen")
            if (response == "LOGOUT") {
                navigate("/");
                return;
            }
            const prased = JSON.parse(response);
            setkathdata(prased);
        }
        setTimeout(() => {
            f();
        }, 250);
    }, []);

    const [createthema, setcreathema] = useState();
    const [titleinput, settitleinput] = useState();
    const [themainput, setthemainput] = useState();
    const [files, setFiles] = useState([]);
    const [selectedsparte, setselectedsparte] = useState();
    const [selectedsub, setselectedsub] = useState();

    function create(files) {
        console.log("Uploading...");

        const formData = new FormData();
        const body = {
            token: Token.get(),
            title: titleinput,
            sparte: selectedsparte ? selectedsparte.name : "Keine",
            subsparte: selectedsub ? selectedsub.name : "Keine",
            inhalt: themainput,
            forumid: Number(id),
        };

        formData.append("json", JSON.stringify(body));

        // Append each file with a unique name or just as "file"
        Array.from(files).forEach((file, idx) => {
            formData.append("file", file); // use "file[]" if backend expects an array
        });

        fetch(url + "/api/forum/upload", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                    setcreathema(false);
                    settitleinput("");
                    setthemainput("");
                    setFiles([]);
                    setselectedsparte(null);
                    setselectedsub(null);
                }
            })
            .catch(console.error);
    }


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("Selected file:", file);
            setFiles((prevFiles) => [...prevFiles, file]);
        }
    };
    const handlekathchange = (newv) => {
        setselectedsparte(newv);
        if (newv == null) {
            setsubs([]);
            return;
        }
        setsubs(newv.subkaths);
    }
    const handlesubkathchange = (newv) => {
        setselectedsub(newv);
    }
    const [expandedItems, setExpandedItems] = useState({});

    const toggleExpanded = (index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                <Box sx={{ width: "96%", flexDirection: "row", display: "flex", alignItems: "center" }}>
                    <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 2, mt: 1, gap: 2 }}>
                        <Input
                            placeholder="Suche..."
                            startDecorator={<SearchIcon />}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{ width: 500 }}
                        />
                        <Button onClick={() => setcreathema(true)}>
                            Thema Erstellen
                        </Button>
                    </Box>
                </Box>

                {
                    createthema && (
                        <Card sx={{ width: "96% ", mb: 2 }}>
                            <Typography level="title-md">Thema erstellen</Typography>
                            <FormControl>
                                <FormLabel>
                                    Themen Titel
                                </FormLabel>
                                <Input value={titleinput} onChange={(e) => settitleinput(e.target.value)} placeholder='Themen Title der kurz erklärt worum es geht'></Input>
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Thema
                                </FormLabel>
                                <Textarea placeholder='Detailierter Inhalt' value={themainput} onChange={(e) => setthemainput(e.target.value)} minRows={3}>
                                </Textarea>
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Sparte
                                </FormLabel>
                                <Autocomplete value={selectedsparte} onChange={(e, newv) => handlekathchange(newv)} options={kathdata?.result} getOptionLabel={(i) => i.name} placeholder='Sparte auf die sich das Thema bezieht Frei lassen für Keine' />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Untersparte
                                </FormLabel>
                                <Autocomplete value={selectedsub} onChange={(e, newv) => handlesubkathchange(newv)} options={subs} getOptionLabel={(i) => i.name} placeholder='Untersparte auf die sich das Thema bezieht Frei lassen für Keine' />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Dateien
                                </FormLabel>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Aktion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            files.map((item) => {

                                                return (
                                                    <tr>
                                                        <td>
                                                            {item.name}
                                                        </td>
                                                        <td>
                                                            <Button onClick={() => {
                                                                setFiles(prevList => prevList.filter(i => i !== item));
                                                            }} color='danger'>Entfernen</Button>
                                                        </td>
                                                    </tr>
                                                )

                                            })
                                        }


                                    </tbody>
                                </Table>
                                <Button component="label" sx={{ mt: 6, width: "10%" }}>
                                    Datei Hochladen
                                    <input
                                        type="file"
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            </FormControl>
                            <Button onClick={() => create(files)} sx={{ width: "10%" }}>Erstellen</Button>
                        </Card>
                    )
                }
                {data && data.sort((a, b) => (b.neucontent === true) - (a.neucontent === true)).filter((i) => i.title.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) || i.thema.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
                || i.Sparte.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) || i.subkath.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).map((item, index) => {
                    const text = item.thema;
                    const isExpanded = expandedItems[index] || false;

                    return (
                        <Card key={index} sx={{ width: "96%", mb: 2 }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <Box sx={{ display: "flex", gap: 2 }}>
                                    <AccountCircleOutlinedIcon sx={{ fontSize: "2.5rem", color: "lightgray" }} />
                                    <Box>
                                        <Link href={window.location.origin + "/viewthemaForum/" + data.id + "/" + item.id}>
                                            <Typography color="primary" level="title-lg">{item.title}</Typography>
                                        </Link>
                                        <Typography mt={-0.5} sx={{ color: "gray" }} level="body-xs">
                                            {item.erstellername} 
                                        </Typography>
                                    </Box>
                                    {
                                        item.neucontent && (
                                            <Typography color='danger'>Neue Einträge</Typography>
                                        )
                                    }

                                </Box>
                                <Box sx={{gap: 2, display: "flex", height: "5%"}}>
                                    <Chip color="warning">Antworten: {item.antwortencount}</Chip>
                                    <Chip color="primary">{item.Sparte}</Chip>
                                    <Chip color="primary">{item.subkath}</Chip>
                                    <Chip color="neutral">Erstellt am {item.stamp.split(":")[0] + ":" + item.stamp.split(":")[1]}</Chip>
                                </Box>
                            </Box>


                            <Typography sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
                                {isExpanded ? text : text.split('\n').slice(0, 3).join('\n') + '...'}
                            </Typography>

                            <Button sx={{ width: "10%" }} onClick={() => toggleExpanded(index)} size="sm" variant="plain">
                                {isExpanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}
                            </Button>
                        </Card>
                    );
                })}




            </div>
            <NavigationBar state={"home"} back={false} />
        </>
    )
}

export default ForumViewer
